export default __webpack_public_path__ + "static/media/yd-product1.b0fd9015.png";